import React from "react"

const PressOutsideContext = React.createContext()

export default PressOutsideContext
